export default __webpack_public_path__ + "static/media/filter.09aa220a.svg";